import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import Page from "../../Common/Page";

const ManageSeasonWrapper = (props) => {
  const { children, data } = props;
  const { formatMessage } = useIntl();

  const title = useMemo(() => `${formatMessage({ id: "season" })} - ${data?.nameLocal}`, [formatMessage, data]);

  return (
    <>
      <Page title={title} tabTitle={title}>
        {children}
      </Page>
    </>
  );
};

export default ManageSeasonWrapper;
